module.exports = __webpack_public_path__ + "static/media/kendrafoundit-IG-3.a9a0eb51.PNG";